import { render, staticRenderFns } from "./WorkshopsTab.vue?vue&type=template&id=5088787d&scoped=true&"
import script from "./WorkshopsTab.vue?vue&type=script&lang=js&"
export * from "./WorkshopsTab.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsTab.vue?vue&type=style&index=0&id=5088787d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088787d",
  null
  
)

export default component.exports